import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import {
  getDeviationsByIds,
  getDeviationById,
} from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getCompositeId } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { DeviationResourceType } from '@wix/da-shared-react/pkg/types/deviation';
import { AppState } from '../../../../../types/store';
import { getModuleDataByModuleType } from '../../../../selectors/modules';
import { ModuleType } from '../../../../../types/modules';
import { getSelectedTierId } from '../../../../selectors/subscriptionsSection';
import { setSelectedTierId } from '../../../../actions/subscriptionsSection';
import { Props } from './TiersDropdown';

type StateProps = Pick<Props, 'tiers' | 'selectedTier'>;
type DispatchProps = Pick<Props, 'setSelectedTierId'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const selectedTierId = getSelectedTierId(state) || undefined;
  const selectedTier =
    (selectedTierId &&
      getDeviationById(
        state,
        getCompositeId(DeviationResourceType.TIER, selectedTierId)
      )) ||
    undefined;
  const { tiers: tiersIds = [] } = getModuleDataByModuleType(
    state,
    ModuleType.TIERS
  );
  const tiers = getDeviationsByIds(state, tiersIds);
  return {
    tiers,
    selectedTier,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setSelectedTierId,
};

export default connect(mapStateToProps, mapDispatchToProps);
